import React, { useState } from 'react';
import { DeleteCoupon, EditCoupon, FetchCoupons } from './CouponFunction';
import DropdownSearch from '../Components/DynamicComp/DropdownSearch';

const CouponCard = ({ coupon,category ,setRefresh}) => {
  const [editMode, setEditMode] = useState(false);
  const [editedCoupon, setEditedCoupon] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [amountError, setAmountError] = useState('');

  const handleEditClick = () => {
    setEditedCoupon({
      ...coupon,
      status: coupon.status || "inactive",
      promotion_start_date: coupon.promotion_start_date?.split("T")[0] || "",
      promotion_end_date: coupon.promotion_end_date?.split("T")[0] || "",
      promotion_type: coupon.promotion_type || ""
    });
    setEditMode(true);
  };

  const handleOk = async() => {
  if (
    editedCoupon.promotion_type === "Percentage" &&
    parseFloat(editedCoupon.amount) >= 100
  ) {
    setAmountError("Percentage must be less than 100");
    return;
  }
    const payload=editedCoupon;
    console.log('Payload Data', payload);
    try{
     await EditCoupon(payload)
     setEditMode(false);
     setRefresh(prev=>!prev)
    }catch(err){
      console.log("ERROR",err);
    }

  };

  const handleCancel = () => {
    setEditedCoupon(null);
    setEditMode(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
  if (name === "amount" && editedCoupon?.promotion_type === "Percentage") {
    if (parseFloat(value) >= 100) {
      setAmountError("Percentage must be less than 100");
    } else {
      setAmountError('');
    }
  }
    setEditedCoupon(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDelete=async(id)=>{
    console.log("Deleted Id",id)
    try {
     await DeleteCoupon(id);
     setShowDeleteConfirm(false);
     setRefresh(prev=>!prev);
    } catch (error) {
      console.log('Error Deleting data',error)
    }

  }

  const displayCoupon = editMode ? editedCoupon : coupon;

  const badgeColor = {
    active: "bg-green-500",
    inactive: "bg-yellow-500",
    expired: "bg-gray-500",
  }[displayCoupon.status] || "bg-gray-300";

  return (
    <div className="relative border border-red-300 rounded-lg shadow-md p-4 mb-6 hover:shadow-lg transition">
      
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-xl font-semibold text-gray-800">
          {editMode ? (
             <input
                type="text"
                name="coupon_code"
                value={editedCoupon.coupon_code}
                onChange={handleInputChange}
                className="text-xl font-semibold text-gray-800 p-1 border rounded w-full"
              />
          ) : (
            `Coupon Code: ${coupon.coupon_code}`
          )}
        </h2>
        <span className={`inline-block ml-2 px-2 py-1 rounded text-white text-sm ${badgeColor}`}>
          {displayCoupon.status || "N/A"}
        </span>
      </div>

      <div>
          <p className="text-gray-600 mb-2 flex justify-between items-center">
            <span className="font-medium">Promotion Start:</span>
            {editMode ? (
              <input type="date" name="promotion_start_date" value={editedCoupon.promotion_start_date} onChange={handleInputChange} className="p-1 border rounded w-1/2"/>
            ) : (
              new Date(coupon.promotion_start_date).toLocaleDateString("en-IN")
            )}
          </p>
          <p className="text-gray-600 mb-2 flex justify-between items-center">
            <span className="font-medium">Promotion End:</span>
            {editMode ? (
              <input type="date" name="promotion_end_date" value={editedCoupon.promotion_end_date} onChange={handleInputChange} className="p-1 border rounded w-1/2"/>
            ) : (
              new Date(coupon.promotion_end_date).toLocaleDateString("en-IN")
            )}
          </p>
          <div className="text-gray-600 mb-2 flex justify-between items-center">
            <span className="font-medium">Promotion Type:</span>
             {editMode ? (
             <select
              name="promotion_type"
              value={editedCoupon.promotion_type || ""}
              onChange={handleInputChange}
              className="p-1 border rounded w-1/2"
             >
             <option value="" disabled>
               Select Promotion Type
              </option>
              <option value="Fixed">Fixed</option>
              <option value="Percentage">Percentage</option>
             </select>
            ) : (
              coupon.promotion_type
            )}
          </div>
          <div className="text-gray-600 mb-2 flex justify-between items-center">
            <span className="font-medium">Category:</span>
            {editMode ? (
              <DropdownSearch
               options={category.map(cat => cat.product_type_name)}
               placeholder="Select Category"
               value={coupon.category}
               onSelect={(selectedValue) =>
               setEditedCoupon(prev => ({ ...prev, category: selectedValue }))
              }
             />
            ) : (
              coupon.category || 'N/A'
            )}
          </div>
          <p className="text-gray-600 mb-2 flex justify-between items-center">
            <span className="font-medium">Amount or %:</span>
            {editMode ? (
              <>
              <input type="number" name="amount" value={editedCoupon.amount} onChange={handleInputChange} className="p-1 border rounded w-1/2"/>
              {amountError && <div className="text-red-600 text-sm mb-2">{amountError}</div>}</>
            ) : (
              coupon.amount
            )}
          </p>
          <p className="text-gray-600 mb-4 flex justify-between items-center">
            <span className="font-medium">Status:</span>
            {editMode ? (
              <select name="status" value={editedCoupon.status} onChange={handleInputChange} className="p-1 border rounded w-1/2">
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
                <option value="expired">Expired</option>
              </select>
            ) : (
              coupon.status
            )}
          </p>
      </div>

      <div className="mt-4 flex justify-between">
        {editMode ? (
          <div className="flex w-full space-x-2">
            <button
              onClick={handleOk}
              className="w-full px-4 py-2 bg-green-500 text-white rounded hover:bg-green-700"
            >
              OK
            </button>
            <button
              onClick={handleCancel}
              className="w-full px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-800"
            >
              Cancel
            </button>
          </div>
        ) : (
          <button
            onClick={handleEditClick}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
          >
            Edit
          </button>
        )}
        {!editMode && (
           showDeleteConfirm ? (
             <div className="flex gap-2">
               <button
                onClick={()=>handleDelete(coupon.id)}
                className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-800"
               >
                 Yes
              </button>
              <button
                onClick={() => setShowDeleteConfirm(false)}
                className="px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-700"
              >
                 No
              </button>
             </div>
           ) : (
              <button
               onClick={() => setShowDeleteConfirm(true)}
               className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-700"
              >
                 Delete
             </button>
             ) 
        )}
      </div>
    </div>
  );
};

export default CouponCard;